const timeMS = {
  TIME_MS_DAY: 86400000,
};

export {
  timeMS
};
